import { NotFoundClient } from "@components/widgets/ErrorPage";
import { useGetClientQuery } from "@src/__generated__/graphql";
import { PageLoading } from "@src/components/modules/clients/page-loading";
import { NavigationClient } from "@src/components/widgets/AppSubNav";
import { getQueryParam } from "@src/utils/routing";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import React, { useState } from "react";
import {
  DocumentsCtx,
  StoreDocuments,
} from "../../documents/listing/StoreDocuments";
import { TableModuleDocuments } from "../../documents/listing/TableModuleDocuments";
import { MixedFilters } from "./MixedFilters";

export const PageDocuments = observer(function PageDocuments() {
  const { query } = useRouter();

  const clientId = getQueryParam("id", query);
  const { data, loading } = useGetClientQuery({ variables: { id: clientId } });

  const [documentsStore] = useState(() => {
    const store = new StoreDocuments(new MixedFilters(clientId), true);
    store.setPrefillFormFields({ clientId });
    return store;
  });

  if (loading) {
    return <PageLoading clientId={clientId} />;
  }

  if (!data?.client) {
    return <NotFoundClient />;
  }

  return (
    <React.Fragment>
      <DocumentsCtx.Provider value={documentsStore}>
        <TableModuleDocuments
          navigation={<NavigationClient id={clientId} variant="page" />}
        />
      </DocumentsCtx.Provider>
    </React.Fragment>
  );
});
